import React from "react";
import { useState, useEffect } from "react";
import deepcopy from "deepcopy";
import FilesUploadModel from "../../media/filesUploadModel/filesUploadModel";
import CustomDropDown from "./customDropdown/CustomDropDown";
import { FilePreview } from "../../media/filePreview/filePreview";
// import { dataURItoFile, filesToBase64 } from "../../../utils";

const FileFactory = (props) => {
  const { requiredFieldsRef, schema, formRef } = props;

  const [files, setFiles] = useState([]);
  const [maxFileCount, setMaxFileCount] = useState(10);
  const [customComponent, setCustomComponent] = useState(null);

  const handleChange = (inpFiles) => {
    // structure of the inpFiles would be {file: fileObject, metadata: metadataObject}
    const copyFileAttribute = deepcopy(formRef.current);
    if (!copyFileAttribute[schema?.path]) {
      copyFileAttribute[schema?.path] = [];
    }

    if (copyFileAttribute[schema?.path].length >= maxFileCount) {
      copyFileAttribute[schema?.path].shift();
    }

    removeRedBorder(schema?.path);

    copyFileAttribute[schema?.path].push(inpFiles);
    setFiles(copyFileAttribute[schema?.path]);
    formRef.current = copyFileAttribute;
  };

  function removeRedBorder(id) {
    const element = document.getElementById(id);

    if (element) {
      element.style.border = "0px";
      element.style.padding = "0px";
    }
  }

  useEffect(() => {
    console.log("inside useEffect", formRef.current);
  }, [files]);

  const handleFileDelete = (index) => {
    if (formRef.current[schema?.path]) {
      const copyFileAttribute = deepcopy(formRef.current);
      const updatedFiles = [...copyFileAttribute[schema?.path]];
      updatedFiles.splice(index, 1);
      copyFileAttribute[schema?.path] = updatedFiles;
      setFiles(updatedFiles);
      formRef.current = copyFileAttribute;
    }
  };
  function extractAudioBlobFromFile(file) {
    return new Promise((resolve, reject) => {
      if (!file || !file.type.startsWith("audio/")) {
        reject(new Error("The provided file is not an audio file."));
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        const audioBlob = new Blob([event.target.result], { type: file.type });
        resolve(audioBlob);
      };

      reader.onerror = (event) => {
        reject(new Error("Error reading the file."));
      };

      reader.readAsArrayBuffer(file);
    });
  }

  const getFilesPreview = () => (
    <div
      className={`filesUploadModel_preview_container ${
        formRef.current[schema?.path]?.length
          ? "preview_available"
          : "preview_empty"
      }`}
    >
      {formRef.current[schema?.path]?.length === 0
        ? ""
        : formRef.current[schema?.path]?.map((itm, idx) => (
            <FilePreview
              {...{
                itm,
                handleFileDelete,
                idx: idx,
                key: idx,
                type: schema?.media,
              }}
            />
          ))}
    </div>
  );

  const createComponent = (type, props) => {
    switch (type) {
      case "dropdown":
        return <CustomDropDown {...props} />;
      default:
        return <FilesUploadModel {...props} />;
    }
  };

  useEffect(() => {
    if (schema?.customComponent) {
      setCustomComponent(schema.customComponent);
    }
    setMaxFileCount(schema?.maxItems ? schema?.maxItems : 10);
    if (
      schema?.file_required &&
      !requiredFieldsRef.current?.includes(schema?.path)
    ) {
      requiredFieldsRef.current = [...requiredFieldsRef.current, schema?.path];
    }
  }, [schema]);

  return (
    <div>
      {createComponent(customComponent, {
        ...props,
        handleChange,
        files,
        setFiles,
      })}
      {getFilesPreview()}
    </div>
  );
};

export default FileFactory;
